//
// Copyright 2025 DXOS.org
//

/**
 * Goes into {@link Message['properties']}
 */
export const MESSAGE_PROPERTY_TOOL_CALL_ID = 'toolCallId' as const;
